import { render, staticRenderFns } from "./MediaVideo.vue?vue&type=template&id=43ba4b72&"
import script from "./MediaVideo.vue?vue&type=script&lang=js&"
export * from "./MediaVideo.vue?vue&type=script&lang=js&"
import style0 from "./MediaVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports